<template>
  <div class="text-center">
    <v-layout row justify-center align-center>
      <v-dialog
        v-model='loading'
        persistent
        width="60"
        >
        <v-card class="pa-0">
          <v-layout wrap align-center justify-center>
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: [ 'loading' ],
  data () {
    return {
    }
  }
}
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}
</style>
